import type { Reaction } from '../api/types';

// Same list as the server (server/src/messages/reactions.ts).
export const REACTION_EMOJIS = ['👍', '❤️', '🔥', '😂', '😮', '😢', '👏'] as const;

export const REACTION_LABELS: Record<string, string> = {
  '👍': 'Нравится',
  '❤️': 'Сердце',
  '🔥': 'Огонь',
  '😂': 'Смешно',
  '😮': 'Удивление',
  '😢': 'Грусть',
  '👏': 'Аплодисменты',
};

export interface ReactionGroup {
  emoji: string;
  count: number;
  mine: boolean;
}

/** Groups reactions by emoji in order of first appearance. */
export function groupReactions(reactions: Reaction[] | undefined, myId: string | undefined): ReactionGroup[] {
  const groups = new Map<string, ReactionGroup>();
  for (const r of reactions ?? []) {
    const g = groups.get(r.emoji) ?? { emoji: r.emoji, count: 0, mine: false };
    g.count++;
    if (myId && r.userId === myId) g.mine = true;
    groups.set(r.emoji, g);
  }
  return [...groups.values()];
}
